module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('v-container', {
    staticClass: "mt-3 resume-view",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    ref: "loader",
    class: ['loader', ("loader--" + (_vm.settingsObj.themeColor)), 'loader-bar-ping-pong', ("" + (_vm.getActiveStatus()))]
  }), _vm._v(" "), ((_vm.currNavItem == 'Experience')) ? _c('card-list', {
    attrs: {
      "settingsObj": _vm.settingsObj,
      "name": _vm.currNavItem.toLowerCase()
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.currNavItem == 'Projects')) ? _c('card-list', {
    attrs: {
      "settingsObj": _vm.settingsObj,
      "name": _vm.currNavItem.toLowerCase()
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.currNavItem == 'Skills')) ? _c('lazy-grid', {
    attrs: {
      "settingsObj": _vm.settingsObj
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.currNavItem == 'References')) ? _c('detail-accordion', {
    attrs: {
      "settingsObj": _vm.settingsObj,
      "endpoint": "references"
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.currNavItem == 'Education')) ? _c('parallax-card-list', {
    attrs: {
      "settingsObj": _vm.settingsObj,
      "endpoint": "education"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "resume-view__nav",
    attrs: {
      "fixed": "",
      "bottom": "",
      "row": "",
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "cardz"
  }, [_c('v-bottom-nav', {
    staticClass: "white",
    attrs: {
      "id": "resume-nav",
      "value": true,
      "active": _vm.currNavItem
    },
    on: {
      "update:active": function($event) {
        _vm.currNavItem = $event
      }
    }
  }, _vm._l((_vm.navItems), function(item, i) {
    return _c('v-btn', {
      key: item.name,
      class: [((_vm.settingsObj.themeColor) + "--text"), 'text--darken-2'],
      attrs: {
        "flat": "",
        "light": "",
        "id": ("" + (item.name)),
        "value": item.name
      },
      on: {
        "click": function (e) {
          _vm.toggleResumeNavItem(e)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-icon', {
      attrs: {
        "id": ("icon-" + (item.name))
      }
    }, [_vm._v(_vm._s(item.icon))])], 1)
  }))], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f8d4aea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Resume.vue
// module id = 453
// module chunks = 0